import { StarShape } from "./HiddenStar";

const COLORS = ["#FFD21F", "#FF5FA8", "#4CC417", "#38B6FF", "#FF8A1F", "#8A3FE0"];

// Short burst of little stars around Bini, played when her sky is complete
export const StarBurst = () => (
  <div className="pointer-events-none absolute left-1/2 top-1/2" aria-hidden="true" data-testid="sky-celebration-burst">
    {Array.from({ length: 12 }).map((_, i) => (
      <span key={i} className="burst-star absolute -ml-3 -mt-3" style={{ "--a": `${i * 30}deg`, animationDelay: `${(i % 3) * 90}ms` }}>
        <StarShape color={COLORS[i % COLORS.length]} className="h-6 w-6" />
      </span>
    ))}
  </div>
);
